import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=ab7e4ce8&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=ab7e4ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7e4ce8",
  null
  
)

export default component.exports